export const withLeadingZero = (value: number) =>
  value.toString().padStart(2, "0");
